{
  "name": "frappe-playground",
  "version": "0.9.0",
  "description": "Run Frappe Framework in the browser via Pyodide",
  "workspaces": [
    "packages/*"
  ],
  "scripts": {
    "start": "vite preview --host 0.0.0.0",
    "dev": "npm run generate:sources && concurrently --kill-others-on-fail --names playground,docs \"vite --host 0.0.0.0 --mode combined\" \"vitepress dev docs --host 127.0.0.1 --port 5174 --strictPort\"",
    "dev:playground": "npm run generate:sources && vite --host 0.0.0.0",
    "generate:sources": "node scripts/generate-python-sources.mjs",
    "build": "npm run build:playground && npm run docs:build",
    "build:playground": "npm run generate:sources && vite build && bash scripts/prepare.sh",
    "docs:dev": "vitepress dev docs",
    "docs:build": "vitepress build docs",
    "docs:preview": "vitepress preview docs",
    "docs:screenshots": "node scripts/capture-docs-screenshots.mjs",
    "build:runtime": "npm run validate:apps && bash scripts/build.sh",
    "validate:apps": "node scripts/validate-app-catalog.mjs",
    "verify:build": "node scripts/verify-build.mjs",
    "test": "npm run test:contract && npm run test:clean-build && npm run test:e2e",
    "test:contract": "npm run generate:sources && node --test tests/contract/*.test.mjs",
    "test:clean-build": "bash scripts/test-clean-build.sh",
    "test:serve": "vite preview --host 127.0.0.1 --port 8102",
    "test:e2e": "playwright test tests/e2e --project=chromium --project=webkit",
    "test:mock-removal": "node scripts/test-mock-removal.mjs",
    "test:mock-removal:list": "node scripts/test-mock-removal.mjs --list",
    "test:e2e:ui": "playwright test --ui",
    "test:e2e:chromium": "playwright test tests/e2e --project=chromium",
    "test:e2e:webkit": "playwright test tests/e2e --project=webkit",
    "predeploy": "bash scripts/prepare-deploy.sh",
    "deploy": "bash scripts/deploy.sh"
  },
  "devDependencies": {
    "@iconify-json/lucide": "^1.2.149",
    "@playwright/test": "^1.64.1",
    "@vitejs/plugin-vue": "^6.0.10",
    "autoprefixer": "^10.6.2",
    "concurrently": "^10.0.6",
    "playwright": "^1.64.1",
    "postcss": "^8.5.32",
    "tailwindcss": "^3.4.19",
    "unplugin-icons": "^24.0.0",
    "vite": "^8.3.5",
    "vitepress": "2.0.0-alpha.21",
    "wrangler": "^4.156.0"
  },
  "dependencies": {
    "@lucide/vue": "^1.66.0",
    "frappe-ui": "^1.1.0",
    "vue": "^3.5.44",
    "vue-router": "^4.6.4"
  }
}
